import React, { useCallback } from "react";
import Multipet from "./multipet.svg";
import { Badge, Button } from "../ui";
import Strings from "@/shared/utils/Strings.constants";
import { ADD_PET_MODAL_TRIGGERS } from "@/shared/utils/constants";
import { useAppLayerContext } from "@/shared/contexts/AppLayer";
import { useMultiPetDiscountCopy } from "@/shared/contexts/MultiPetDiscount";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlus } from "@fortawesome/pro-regular-svg-icons";

type AddPetBannerVariant = "banner" | "inline-cta";

interface AddPetBannerProps {
    variant?: AddPetBannerVariant;
}

function AddPetBanner({ variant = "banner" }: AddPetBannerProps) {
    const { updateAppState } = useAppLayerContext();
    const multiPetCopy = useMultiPetDiscountCopy();

    const openAddPetModal = useCallback(() => {
        updateAppState({ addPetModal: ADD_PET_MODAL_TRIGGERS.ALT_SUBMIT_CTA });
    }, [updateAppState]);

    if (variant === "inline-cta") {
        return (
            <div data-testid="add-pet-inline-cta">
                <Button
                    variant="default"
                    size="lg"
                    className="w-full rounded-xl border border-stroke-primary bg-background-primary px-3 py-2 text-content-primary hover:bg-background-secondary"
                    onClick={openAddPetModal}
                    startDecorator={<FontAwesomeIcon icon={faCirclePlus} className="mr-2 size-4" />}
                >
                    <span className="flex items-center gap-4">
                        {Strings.ADD_ADDITIONAL_PET}
                        <Badge variant="success" className="h-5 uppercase text-content-primary-invert">
                            {multiPetCopy.saveBadge}
                        </Badge>
                    </span>
                </Button>
                <p className="mt-2 flex justify-center text-xs font-bold leading-4 text-content-primary">{Strings.LOCK_IN_SAVINGS}</p>
            </div>
        );
    }

    return (
        <div data-testid="add-pet-banner" className="mt-4 rounded-lg bg-background-warning pb-3 pl-3 pt-2 sm:px-4 sm:py-3 md:pb-3 md:pl-3 md:pt-2 lg:px-4 lg:py-3 xl:px-4">
            <div className="flex items-center justify-between ">
                <div className="sm:flex sm:w-full sm:items-center sm:justify-between md:block lg:flex lg:justify-between">
                    <div className="flex flex-col">
                        <div className="text-sm font-bold leading-5 text-content-primary">{multiPetCopy.addPetCta}</div>
                        <div className="mt-1 text-xs font-medium leading-4 text-content-secondary">{Strings.LOCK_IN_SAVINGS}</div>
                    </div>

                    <Button
                        variant="secondary"
                        size="xs"
                        className="mt-2 min-w-[115px] rounded-full px-2 py-1 text-xs font-medium leading-4 sm:ml-auto sm:mr-5 md:mr-0 lg:mr-4 xl:mr-5"
                        onClick={openAddPetModal}
                    >
                        {Strings.ADD_ADDITIONAL_PET}
                    </Button>
                </div>

                <Multipet aria-hidden="true" className="-mb-11 shrink-0 sm:-mb-5 sm:-mt-4 md:-mb-11 md:-mt-0 lg:-mb-5 xl:-mt-4" />
            </div>
        </div>
    );
}

export default AddPetBanner;
